import type { Author, MediaItem, ResolveResponse } from "./types";

const columns = [
  "record_type", "post_id", "username", "display_name", "text", "published_at",
  "permalink", "media_count", "media_urls"
] as const;

function escapeCell(value: string | number): string {
  const text = String(value);
  return /[",\r\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
}

function row(values: readonly (string | number)[]): string {
  return values.map(escapeCell).join(",");
}

function authorValues(author: Author): [string, string] {
  return [author.username, author.displayName || ""];
}

function mediaURLs(media: MediaItem[]): string {
  return media.map((item) => item.url).join("\n");
}

export function buildProfileCsv(result: ResolveResponse): string {
  if (!result.profile) return `${row(columns)}\r\n`;
  const rows = [row(columns)];
  rows.push(row([
    "profile", "", ...authorValues(result.author), result.profile.biography || "",
    "", result.source.canonicalUrl, 0, ""
  ]));
  for (const post of result.profile.posts) {
    rows.push(row([
      "profile_post", post.postId, ...authorValues(post.author), post.text,
      post.publishedAt || "", post.permalink, post.media.length, mediaURLs(post.media)
    ]));
    if (post.quotedPost) {
      rows.push(row([
        "quoted_post", post.quotedPost.postId, ...authorValues(post.quotedPost.author),
        post.quotedPost.text, "", "", post.quotedPost.media.length, mediaURLs(post.quotedPost.media)
      ]));
    }
  }
  return `${rows.join("\r\n")}\r\n`;
}
